import { render, staticRenderFns } from "./ClockEditionCard.vue?vue&type=template&id=3995922e&"
import script from "./ClockEditionCard.vue?vue&type=script&lang=js&"
export * from "./ClockEditionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports